import '../../Styles/QuoteSlider/quoteSlider.scss';

window.am = window.am || {};

window.am.quoteSlider = new function () {
    var that = this;

    that.setTextboxHeight = function (slider) {

        const slickList = slider.querySelector(".slick-list");
        if (!slickList) {
            return;
        }

        slickList.style.height = "auto";

        var textboxes = slider.querySelectorAll('.quote-slider-element .quote-text-box');
        var highestTextBox = 0;

        textboxes.forEach(function (textbox) {
            textbox.style.height = "auto";
        });

        textboxes.forEach(function (textbox) {
            if (textbox.offsetHeight > highestTextBox) {
                highestTextBox = textbox.offsetHeight;
            }
        });

        textboxes.forEach(function (textbox) {
            textbox.style.height = highestTextBox + "px";
        });

        var imageContainers = slider.querySelectorAll(".img-container");

        var isExperienceEditor = slider.querySelector(".isExperienceEditor");
        var isPreviewMode = slider.querySelector(".isPreview");

        if (window.innerWidth >= 1024) {
            imageContainers.forEach(function (container) {
                // 56px -> space between textbox and end/start of quote element container       
                container.style.height = highestTextBox + 56 + 56 + "px";
            });
        }
        else {
            imageContainers.forEach(function (container) {
                // 56px -> space between textbox and end/start of quote element container       
                container.style.height = "auto";
            });
        }

        let elements = slider.querySelectorAll('.quote-slider-element ');
        let highestElement = 0;

        elements.forEach(function (element) {
            var img = element.querySelector('img');

            if (img.classList.contains('lazyloading') || img.classList.contains('lazyloaded')) {
                if (element.offsetHeight > highestElement) {
                    highestElement = element.offsetHeight;
                }
            }
        });

        slickList.style.maxHeight = highestElement + "px";

        if (isExperienceEditor || isPreviewMode) {
            imageContainers.forEach(function (container) {
                if (!container.firstElementChild) {
                    var tag = document.createElement("p");
                    var imageSize = document.createTextNode("Bildcontainergröße: Breite x Höhe -> " + container.offsetWidth + "x" + container.offsetHeight);
                    tag.appendChild(imageSize);
                    container.appendChild(tag);
                    container.style.border = "thin dotted #565656";
                }
            });
        }
    };

    that.setTabindexForNavigation = function (slider) {
        var prev = slider.querySelector('.prev');
        var next = slider.querySelector('.next');

        if (prev && next) {
            prev.setAttribute('tabindex', '0');
            next.setAttribute('tabindex', '0');
        }
    }

    that.MakePaginationVisible = function (slider) {
        var pagination = slider.querySelector(".pagination");

        $(slider).on('afterChange', function (event, slick, currentSlide) {
            if ($(slick)[0].$slides.closest(".slick-active").find(".quote-slider-element").length == 0) {
                pagination.classList.add("no-element");
            }
            else {
                pagination.classList.remove("no-element");
            }
        });
    }


    that.init = function () {
        const quoteSlider = document.querySelectorAll('.quote-slider-container');

        quoteSlider.forEach(function (slider) {
            var isExperienceEditor = slider.classList.contains('scEnabledChrome');

            if (isExperienceEditor) {
                that.MakePaginationVisible(slider);
            }

            that.setTabindexForNavigation(slider);
            that.setTextboxHeight(slider);

            $(slider).find('img.lazyload').on('load', function () {
                that.setTextboxHeight(slider);
            });

            window.addEventListener('resize', function () {
                that.setTextboxHeight(slider);
            });

            window.addEventListener('orientationchange', function () {
                that.setTextboxHeight(slider);
            });
        });
    };
};

window.am.quoteSlider.init();
